module.exports = __webpack_public_path__ + "static/media/jedi.8b3b6979.svg";